var React = require('react');

function ContentIndex (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.79 2.807c0 .723-.582 1.307-1.302 1.307A1.308 1.308 0 011.49 1.5c.717 0 1.3.585 1.3 1.307zM2.79 8.03c0 .722-.582 1.307-1.302 1.307-.718 0-1.3-.585-1.3-1.307 0-.723.582-1.308 1.303-1.308.717.003 1.3.588 1.3 1.308zM2.79 13.255c0 .723-.582 1.307-1.302 1.307-.718 0-1.3-.584-1.3-1.307 0-.722.582-1.307 1.303-1.307.717 0 1.3.585 1.3 1.307zM5.396 3.46h9.766c.36 0 .65-.292.65-.653a.65.65 0 00-.65-.652H5.396a.65.65 0 00-.65.652c0 .361.29.652.65.652zM15.162 7.378H5.396a.65.65 0 00-.65.652c0 .361.29.652.65.652h9.766c.36 0 .65-.291.65-.652a.65.65 0 00-.65-.652zM15.162 12.603H5.396a.65.65 0 00-.65.652c0 .362.29.652.65.652h9.766c.36 0 .65-.29.65-.652a.65.65 0 00-.65-.652z","fill":"#fff"}));
}

ContentIndex.defaultProps = {"fill":"none","viewBox":"0 0 16 16"};

module.exports = ContentIndex;

ContentIndex.default = ContentIndex;
